// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.client-db-page {
  padding-left: 8%;
  overflow: auto;
  max-height: 90vh;
  height: 100%;
  width: 85%;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.client-db-page .chip {
  border: 0.0825rem solid #E3E8EC;
  color: #EE926B;
  font-weight: 500;
  background-color: #fff;
}
.client-db-page__button-container {
  height: 3rem;
  width: 70%;
  margin-top: 6rem;
  display: flex;
  flex-direction: row;
  gap: 20px;
}
.client-db-page__button-container__button {
  width: 14rem;
  height: 2rem;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 214, 166, 0.4196078431);
  cursor: pointer;
}
.client-db-page table {
  height: fit-content;
  border-collapse: collapse;
  width: 70%;
  box-shadow: 0 0 1.25rem rgba(0, 0, 0, 0.15);
  margin-bottom: 20px;
}
.client-db-page th {
  border: 0.0625rem solid #ddd;
  padding: 0.67rem;
  border-top: none;
}
.client-db-page th:first-child {
  border-left: none;
}
.client-db-page th:last-child {
  border-right: none;
}
.client-db-page td:not(:last-child) {
  border-left: 0.0625rem solid #ddd;
  border-right: 0.0625rem solid #ddd;
  padding: 1rem;
  text-align: center;
  width: fit-content;
  text-wrap: nowrap;
}
.client-db-page td:not(:last-child):first-child {
  border-left: none;
}
.client-db-page th {
  color: #666;
  font-size: 0.8125rem;
  font-weight: 500;
}
.client-db-page .modify {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  height: 100%;
}

.confirmation-popup {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  padding: 20px;
  z-index: 1000;
  border: 1px solid black;
  border-radius: 8px;
  gap: 10px;
}
.confirmation-popup__button-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 20px;
  align-items: center;
}
.confirmation-popup__button-container__button {
  width: 6rem;
  height: 2rem;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 214, 166, 0.4196078431);
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/features/admin/components/client-db-page/client-db-page.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AACJ;AAAQ;EACE,+BAAA;EACA,cAAA;EACA,gBAAA;EACA,sBAAA;AAEV;AAAQ;EACE,YAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAEV;AADU;EACE,YAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mDAAA;EACA,eAAA;AAGZ;AAAQ;EACI,mBAAA;EACA,yBAAA;EACA,UAAA;EACA,2CAAA;EACA,mBAAA;AAEZ;AACU;EACE,4BAAA;EACA,gBAAA;EACA,gBAAA;AACZ;AAAY;EACI,iBAAA;AAEhB;AAAY;EACI,kBAAA;AAEhB;AACU;EACE,iCAAA;EACA,kCAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AACZ;AACY;EACI,iBAAA;AAChB;AAEU;EACE,WAAA;EACA,oBAAA;EACA,gBAAA;AAAZ;AAEU;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,mBAAA;EACA,YAAA;AAAZ;;AAIA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,uBAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,SAAA;AADF;AAEE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AAAJ;AACE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mDAAA;EACA,eAAA;AACJ","sourcesContent":[".client-db-page{\n    padding-left: 8%;\n    overflow: auto;\n    max-height: 90vh;\n    height: 100%;\n    width: 85%;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n        .chip{\n          border: 0.0825rem solid #E3E8EC;\n          color:#EE926B;\n          font-weight: 500;\n          background-color: #fff;\n        }\n        &__button-container{\n          height: 3rem;\n          width: 70%;\n          margin-top: 6rem;\n          display: flex;\n          flex-direction: row;\n          gap: 20px;\n          &__button{\n            width: 14rem;\n            height: 2rem;\n            border-radius: 5px;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            background-color: #FFD6A66B;\n            cursor: pointer;\n          }\n        }\n        table {\n            height: fit-content;\n            border-collapse: collapse;\n            width: 70%;\n            box-shadow: 0 0 1.25rem rgba(0, 0, 0, 0.15);\n            margin-bottom: 20px;\n          }\n          \n          th {\n            border: 0.0625rem solid #ddd;\n            padding: 0.67rem;\n            border-top: none;\n            &:first-child {\n                border-left: none;\n            }\n            &:last-child {\n                border-right: none;\n            }\n          }\n          td:not(:last-child) {\n            border-left: 0.0625rem solid #ddd;\n            border-right: 0.0625rem solid #ddd;\n            padding: 1rem;\n            text-align: center;\n            width: fit-content;\n            text-wrap: nowrap;\n          \n            &:first-child {\n                border-left: none;\n            }\n          }\n          th {\n            color: #666;\n            font-size: 0.8125rem;\n            font-weight: 500;\n          }\n          .modify{\n            cursor: pointer;\n            display: flex;\n            flex-direction: row;\n            justify-content: space-around;\n            align-items: center;\n            height: 100%;\n          }\n        }\n\n.confirmation-popup{\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: white;\n  padding: 20px;\n  z-index: 1000;\n  border: 1px solid black;\n  border-radius: 8px;\n  gap: 10px;\n  &__button-container{\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    gap: 20px;\n    align-items: center;\n  &__button{\n    width: 6rem;\n    height: 2rem;\n    border-radius: 5px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: #FFD6A66B;\n    cursor: pointer;\n  }\n}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
